import { render, staticRenderFns } from "./bidding-detail.vue?vue&type=template&id=636aeeee&scoped=true"
import script from "./bidding-detail.vue?vue&type=script&lang=js"
export * from "./bidding-detail.vue?vue&type=script&lang=js"
import style0 from "./bidding-detail.vue?vue&type=style&index=0&id=636aeeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636aeeee",
  null
  
)

export default component.exports